// API URL - Use relative path so requests go through the same origin (proxied by CRA dev server).
// REACT_APP_API_URL can override this for production builds (e.g. "https://api.example.com/api").
export const API_URL = process.env.REACT_APP_API_URL || '/api';

// Module types
export const MODULE_TYPES = {
  INPUT: 'input',
  TRANSFORM: 'transform',
  AI_ENRICHMENT: 'ai_enrichment',
  CUSTOM_CODE: 'custom_code',
  OUTPUT: 'output'
};

// Pipeline statuses
export const PIPELINE_STATUS = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  PAUSED: 'paused',
  ARCHIVED: 'archived'
};

// Run statuses
export const RUN_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
};

// Alert severities
export const ALERT_SEVERITY = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  CRITICAL: 'critical'
};

// Alert statuses
export const ALERT_STATUS = {
  ACTIVE: 'active',
  ACKNOWLEDGED: 'acknowledged',
  RESOLVED: 'resolved',
  IGNORED: 'ignored'
};

// Node colors by type
export const NODE_COLORS = {
  [MODULE_TYPES.INPUT]: {
    background: '#e6f7ff',
    border: '#1890ff',
    text: '#0050b3'
  },
  [MODULE_TYPES.TRANSFORM]: {
    background: '#f6ffed',
    border: '#52c41a',
    text: '#135200'
  },
  [MODULE_TYPES.AI_ENRICHMENT]: {
    background: '#fff1f0',
    border: '#ff4d4f',
    text: '#a8071a'
  },
  [MODULE_TYPES.CUSTOM_CODE]: {
    background: '#fcf4dc',
    border: '#faad14',
    text: '#ad6800'
  },
  [MODULE_TYPES.OUTPUT]: {
    background: '#f9f0ff',
    border: '#722ed1',
    text: '#391085'
  }
};

// Status colors
export const STATUS_COLORS = {
  [RUN_STATUS.PENDING]: '#faad14',
  [RUN_STATUS.RUNNING]: '#1890ff',
  [RUN_STATUS.COMPLETED]: '#52c41a',
  [RUN_STATUS.FAILED]: '#ff4d4f',
  [RUN_STATUS.CANCELLED]: '#bfbfbf',
  
  [PIPELINE_STATUS.DRAFT]: '#bfbfbf',
  [PIPELINE_STATUS.ACTIVE]: '#52c41a',
  [PIPELINE_STATUS.PAUSED]: '#faad14',
  [PIPELINE_STATUS.ARCHIVED]: '#8c8c8c',
  
  [ALERT_SEVERITY.INFO]: '#1890ff',
  [ALERT_SEVERITY.WARNING]: '#faad14',
  [ALERT_SEVERITY.ERROR]: '#ff4d4f',
  [ALERT_SEVERITY.CRITICAL]: '#a8071a',
  
  [ALERT_STATUS.ACTIVE]: '#ff4d4f',
  [ALERT_STATUS.ACKNOWLEDGED]: '#faad14',
  [ALERT_STATUS.RESOLVED]: '#52c41a',
  [ALERT_STATUS.IGNORED]: '#bfbfbf'
};
